(ns iris.analytics.events
  (:require
   [re-frame.core :as re-frame]
   [ajax.core :as ajax]
   [iris.utils :as utils]
   [iris.events :as events]))



(re-frame/reg-event-fx
 ::set-report
 (fn [{:keys [db]} [_ report]]
   (let [new-db (assoc-in db [:analytics :report] report)]
     (cond-> {:db new-db}
       (:route new-db)
       (assoc :dispatch [:iris.route-data.events/sync-route-data (:route new-db)])))))

(re-frame/reg-event-db
 ::set-ws
 (fn [db [_ ws]]
   (assoc-in db [:analytics :ws] ws)))


(re-frame/reg-event-db
 ::get-analytics-report-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ _ data]]
   (-> db
       (assoc-in [:analytics :data] data)
       (assoc-in [:loading] false))))


(re-frame/reg-event-db
 ::get-analytics-report-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
  ;;  (assoc-in db [:loading] false)
   (-> db
       (assoc-in [:loading] false)
      ;;  (assoc-in [:message] "Analytics API failure!")
       )))


(re-frame/reg-event-fx
 ::get-analytics-report
 (fn [{:keys [db]} [_ report ws t]]
   {:http-xhrio (events/track-http-xhrio
                 "Analytics report"
                 {:method          :get
                  ;;  :uri             (str "http://localhost:8080/" report)
                  :uri (str (utils/get-analytics-service-url) ws "/" (when (not (empty? t)) (str t "/")) report)
                  :timeout         8000                                           ;; optional see API docs
                  ;;  :response-format (ajax/text-response-format)  ;; IMPORTANT!: You must provide this.
                                          ;;    :headers {"Authorization" (str "Bearer " jwt)
                                          ;;              "Content-Type" "application/json; charset=UTF-8"}
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::get-analytics-report-success {:result {:message "Analytics report loaded."}}]
                  :on-failure      [::get-analytics-report-failure {:error {:message "Analytics report failed."}}]})

    :db (-> db
            (assoc-in [:loading] true))}))


;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(re-frame/reg-event-db
 ::get-total-report-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ _ data]]
   (-> db
       (assoc-in [:analytics :total] data)
       (assoc-in [:loading] false))))


(re-frame/reg-event-db
 ::get-total-report-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
  ;;  (assoc-in db [:loading] false)
   (-> db
       (assoc-in [:loading] false)
      ;;  (assoc-in [:message] "Analytics API failure!")
       )))


(re-frame/reg-event-fx
 ::get-total-report
 (fn [{:keys [db]} [_ ws]]
   {:http-xhrio (events/track-http-xhrio
                 "Analytics total"
                 {:method          :get
                  :uri (str (utils/get-analytics-service-url) ws "/realtimetotal")
                  :timeout         8000                                           ;; optional see API docs
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::get-total-report-success {:result {:message "Analytics total loaded."}}]
                  :on-failure      [::get-total-report-failure {:error {:message "Analytics total failed."}}]})

    :db (-> db
            (assoc-in [:loading] true))}))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(re-frame/reg-event-db
 ::get-analytics-tables-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ _ data]]
  ;;  TODO: impure effect
   (set! (.-selectedIndex (.getElementById js/document "archive-select")) 0)
   (-> db
       (assoc-in [:analytics :tables] data)
       (assoc-in [:analytics :data] nil)
       (assoc-in [:loading] false))))


(re-frame/reg-event-db
 ::get-analytics-tables-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (-> db
       (assoc-in [:loading] false)
      ;;  (assoc-in [:message] "Analytics API failure!")
       )))

(re-frame/reg-event-fx
 ::get-analytics-tables
 (fn [{:keys [db]} [_ ws]]
   {:http-xhrio (events/track-http-xhrio
                 "Analytics archives"
                 {:method          :get
                  :uri (str (utils/get-analytics-service-url) ws "/listtables")
                  :timeout         8000                                           ;; optional see API docs
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::get-analytics-tables-success {:result {:message "Analytics archives loaded."}}]
                  :on-failure      [::get-analytics-tables-failure {:error {:message "Analytics archives failed."}}]})

    :db (-> db
            (assoc-in [:loading] true))}))
